
import React from 'react';
import { DisplaySlide } from '../layout/DisplaySlide';
import { ContentSection } from '../layout/ContentSection';
import { SectionGrid } from '../layout/SectionGrid';
import { ScrollingText } from '../layout/ScrollingText';

interface StudyItem {
  type: string;
  lesson: string;
}

interface StudySlideProps {
  items: StudyItem[];
  title?: string;
}

export const StudySlide: React.FC<StudySlideProps> = ({
  items,
  title
}) => {
  return (
    <DisplaySlide background="default" padding="md">
      <div className="h-full flex flex-col space-y-6">
        {/* Study Items Grid - removed title section completely */}
        <SectionGrid 
          columns={items.length > 2 ? 2 : 1} 
          gap="md" 
          className="flex-1"
        >
          {items.map((item, index) => (
            <ContentSection
              key={index}
              title={item.type}
              height="fixed"
              textSize="md"
            >
              <ScrollingText
                text={item.lesson}
                maxLines={3}
                scrollInterval={4000}
                className="text-center"
              />
            </ContentSection>
          ))}
        </SectionGrid>
      </div>
    </DisplaySlide>
  );
};
